/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";

interface SemiCircleRadialChartProps {
  title: string;
  percent: number; // breachInProgressPercent
  count: number; // breachInProgressCount
  total: number;
}

export default function SemiCircleRadialChart({
  title,
  percent,
  count,
  total,
}: Readonly<SemiCircleRadialChartProps>) {
  /** Series */
  const series = useMemo(() => [Number(percent.toFixed(2))], [percent]);

  /** Options */
  const options = useMemo<ApexCharts.ApexOptions>(
    () => ({
      chart: {
        type: "radialBar",
        offsetY: -20,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#E6F0EE",
            strokeWidth: "97%",
            margin: 5,
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: "#444",
              opacity: 0.2,
              blur: 2,
            },
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: -5,
              fontSize: "22px",
              fontWeight: 600,
              formatter: (val: number) => `${val}%`,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          shadeIntensity: 0.4,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 65, 91],
        },
      },
      labels: ["Breach In Progress"],
      colors: ["#e65c66"],
    }),
    [],
  );

  const [state, setState] = useState({ series, options });

  useEffect(() => {
    setState({ series, options });
  }, [series, options]);

  return (
    <div className="flex flex-col items-center">
      <div className="mb-2 font-semibold text-lg">{title}</div>

      <ReactApexChart
        options={state.options}
        series={state.series}
        type="radialBar"
        height={220}
      />

      <div className="mt-2 text-sm font-medium flex gap-4">
        <span>Breach In Progress: {count}</span>
        <span>Total: {total}</span>
      </div>
    </div>
  );
}
